import { z } from 'zod';

export const HiringCopilotJobTitleModelEntry = z
  .object({
    jobTitleOrJobTitleGroup: z.string(),
    alias: z.string().default('prod'),
  })
  .describe('HiringCopilotJobTitleModelEntry');

export type HiringCopilotJobTitleModelEntry = z.infer<
  typeof HiringCopilotJobTitleModelEntry
>;

export const HiringCopilotModelByJobTitleConfig = z
  .object({
    usePretrainedModel: z.boolean().default(false),
    /** When true, each entry's jobTitle is a job title group; when false, a job title. Stored so we know which to use at runtime. */
    useJobTitleGroups: z.boolean().default(false),
    modelByJobTitle: z.array(HiringCopilotJobTitleModelEntry).default([]),
  })
  .describe('HiringCopilotModelByJobTitleConfig');

export type HiringCopilotModelByJobTitleConfig = z.infer<
  typeof HiringCopilotModelByJobTitleConfig
>;
